import React, { useEffect, useState, useCallback } from "react";
import OrderFilter from "./OrderFilter";
import OrderResult from "./OrderResult";
import { ContactMain, ContactContainer } from "./styles/MyOrdersStyles";
import { ORDERS } from "../../../constants/apiEndPoints";
import Loader from "../../shared/loader";
import { toast } from "react-hot-toast";
import httpRequest from "../../../axios/index";
import MainButton from "../../shared/Button";
import { CustomScrollbarStyle } from "../messages/styles/ScrollbarStyles";
import NotFoundIcon from "../../shared/NotFoundIcon";
import { CancelOrderByID } from "../../../services/orders/Orders";

const MyOrders = () => {
  const [Loading, setLoading] = useState(false);
  const [OrderData, SetOrderData] = useState([]);
  const [SelectedFilter, SetSelectedFilter] = useState(null);
  const [ButtonsFilter, SetButtonsFilter] = useState(null);
  const [Page, setPage] = useState(1);
  const [IsLastPage, setIsLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const [cancenLoading, setcancenLoading] = useState(false);
  const scrollbarHeight = "75vh";

  useEffect(() => {
    GetAllOrders();
  }, [SelectedFilter, ButtonsFilter, Page]);

  const GetAllOrders = async () => {
    let param = `?page=${Page}`;

    if (SelectedFilter) {
      param = param + `&filter=${SelectedFilter?.value}`;
    }
    if (ButtonsFilter) {
      let statusData;
      if (ButtonsFilter === "All") {
        statusData = "";
      } else if (ButtonsFilter === "Completed") {
        statusData = "completed";
      } else if (ButtonsFilter === "Cancelled") {
        statusData = "cancelled";
      } else if (ButtonsFilter === "In Progress") {
        statusData = "in_progress";
      } else if (ButtonsFilter === "Pending") {
        statusData = "pending";
      }
      param = param + `&status=${statusData}`;
    }

    try {
      if (Page === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }
      const resp = await httpRequest.get(`${ORDERS}${param}`);
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          setIsLastPage(resp?.data?.last_page);
          if (resp?.data?.data) {
            if (Page === 1) {
              SetOrderData(resp?.data?.data);
            } else {
              SetOrderData((prevData) => [...prevData, ...resp?.data?.data]);
            }
          } else {
            SetOrderData([]);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handlePagination = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const HandelCancel = useCallback(
    async (id) => {
      const indexToUpdate = OrderData.findIndex((obj) => obj.order_id === id);

      const res = await CancelOrderByID(id, setcancenLoading);

      if (res.status === 200) {
        const UpdatedObject = res?.data?.data;

        if (indexToUpdate !== -1) {
          const newArray = [
            ...OrderData.slice(0, indexToUpdate),
            UpdatedObject,
            ...OrderData.slice(indexToUpdate + 1),
          ];
          SetOrderData(newArray);
        }
      }
    },
    [OrderData]
  );

  return (
    // <OrdersLayout>
    <ContactMain>
      <OrderFilter
        SetSelectedFilter={SetSelectedFilter}
        SetButtonsFilter={SetButtonsFilter}
        Page={Page}
        setPage={setPage}
      />

      {Loading && <Loader />}

      <ContactContainer>
        <CustomScrollbarStyle scrollbarHeight={scrollbarHeight}>
          {!Loading && OrderData && OrderData?.length > 0
            ? OrderData?.map((items) => {
                const {
                  order_id,
                  stops = [],
                  order_statuses = [],
                  status = "",
                } = items;

                return (
                  <OrderResult
                    order_id={order_id}
                    stops={stops}
                    StatueTime={order_statuses[0]?.timestamp}
                    status={status}
                    key={order_id}
                    HandelCancel={HandelCancel}
                    cancenLoading={cancenLoading}
                  />
                );
              })
            : !Loading && <NotFoundIcon MT="20" />}
          <div className="loadMore_main">
            {!Loading && !IsLastPage && OrderData?.length > 0 && (
              <MainButton
                type="button"
                label="Load More"
                isLoading={loadingMore}
                MT="0"
                onClick={handlePagination}
              />
            )}
          </div>
        </CustomScrollbarStyle>
      </ContactContainer>
    </ContactMain>
    // </OrdersLayout>
  );
};

export default MyOrders;
